<div class="form-field">
  <label *ngIf="label" [class.disabled]="disabled" [for]="id" class="form-label mb-1">{{label}}</label>
  <textarea nbInput [resize]="false" [rows]="rows" [appFocus]="focus" [disabled]="disabled" class="textarea-custom scroll-y" maxlength="{{maxLength}}" [(ngModel)]="model"  [fullWidth]="fullWidth" [placeholder]="placeholder"></textarea>
  <div *ngIf="help" class="form-help">{{help}}</div>
</div>

